(() => {
  const root = document.querySelector('[data-nawa-track-order-page]');
  const labelsNode = root?.querySelector('[data-nawa-track-order-labels]');
  if (!root || !labelsNode) return;

  let labels;
  try {
    labels = JSON.parse(labelsNode.textContent);
  } catch {
    return;
  }

  const setText = (node, text) => {
    if (node && node.textContent.trim() !== text) node.textContent = text;
  };

  const enhance = () => {
    const app = root.querySelector('#pp-tracking-page-app');
    const orderInputs = app?.querySelectorAll('.pp_action_one [name="order"]');
    const emailInputs = app?.querySelectorAll('.pp_action_one [name="email"]');
    if (!app || !orderInputs?.length || !emailInputs?.length) return false;

    app.querySelectorAll('.pp_action_one .pp_tracking_parent:first-child .pp_tracking_span > span').forEach((node) => setText(node, labels.order));
    app.querySelectorAll('.pp_action_one .pp_tracking_parent:nth-child(2) .pp_tracking_span > span').forEach((node) => setText(node, labels.email));
    app.querySelectorAll('.pp_action_one .pp_enter_submit0').forEach((node) => setText(node, labels.track));

    orderInputs.forEach((input) => {
      input.setAttribute('aria-label', labels.order);
      input.setAttribute('autocomplete', 'off');
    });
    emailInputs.forEach((input) => {
      input.setAttribute('aria-label', labels.email);
      input.setAttribute('autocomplete', 'email');
      input.setAttribute('inputmode', 'email');
    });

    root.dataset.nawaTrackOrderReady = 'true';
    return true;
  };

  if (enhance()) return;

  const observer = new MutationObserver(() => {
    if (enhance()) observer.disconnect();
  });
  observer.observe(root, { childList: true, subtree: true });
  window.setTimeout(() => observer.disconnect(), 10000);
})();
